@if (isOpen) {
    <app-product-advice
        [questionSet]="questions"
        [initialValues]="state.advice"
        (answersUpdated)="evaluateAdvice($event)"
        (submit)="submit()"
    />
    @if (showAdvice()) {
        <app-product-advice-result-box
            [wrongInsurance]="wrongInsurance()"
            (applyAdvice)="this.submit()"
        />
    }
}
